import { render, staticRenderFns } from "./PreparedSentMessageForm.vue?vue&type=template&id=5a5f0a47&"
import script from "./PreparedSentMessageForm.vue?vue&type=script&lang=js&"
export * from "./PreparedSentMessageForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports